/**
 * Studio Zuiver: keeps the available-sizes list on one line.
 * Renders all sizes, then hides the ones that don't fit and adds them to the "+N" counter.
 * Re-queries the DOM on every pass because section updates morph the markup in place.
 */
class ProductCardSizes extends HTMLElement {
  connectedCallback() {
    this.fit = this.fit.bind(this);
    this.schedule = this.schedule.bind(this);
    this.resizeObserver = new ResizeObserver(this.schedule);
    this.resizeObserver.observe(this);
    this.mutationObserver = new MutationObserver(this.schedule);
    this.mutationObserver.observe(this, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-hidden'] });
    this.fit();
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.mutationObserver) this.mutationObserver.disconnect();
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  schedule() {
    if (this.frame) cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(this.fit);
  }

  fit() {
    this.frame = null;
    const list = this.querySelector('.product-card__sizes-list');
    if (!list || list.clientWidth === 0) return;
    const items = Array.from(list.querySelectorAll('.product-card__size:not(.product-card__size--more)'));
    const more = list.querySelector('.product-card__size--more');
    const baseHidden = parseInt(this.dataset.hidden || '0', 10) || 0;
    const fits = () => list.scrollWidth <= list.clientWidth + 1;
    const updateMore = (count) => {
      if (!more) return;
      more.hidden = count === 0;
      more.textContent = '+' + count;
    };

    items.forEach((item) => (item.hidden = false));
    let hidden = baseHidden;
    updateMore(hidden);
    for (let i = items.length - 1; i > 0 && !fits(); i--) {
      items[i].hidden = true;
      hidden++;
      updateMore(hidden);
    }
  }
}

if (!customElements.get('product-card-sizes')) {
  customElements.define('product-card-sizes', ProductCardSizes);
}
